<!-- <p>flucelvax-referenceparagraph works!</p> -->
@if (referncenode | async; as item) {
  <section class="col-12 hidden-xs hidden-sm d-none d-md-block no-padding animationbottom">
    <div class="cbsanimationbelow">
      <div [innerHTML]="item.largeparagraphcontent"></div>
    </div>
    @if (referncenode | async; as item) {
      <a [href]="getpdf(item?.media)"  target="_blank" download="" class="product_download-button">
        <span>{{item?.h2content}}</span>
        <img alt="Download" src="../../../app/../assets/images/product_download_icon.svg">
      </a>
    }
  </section>
}
@if (referncenode | async; as item) {
  <section class="col-12 d-md-none d-lg-none no-padding cellBasedSolution">
    <div class="mobileanimationbelow">
      <div [innerHTML]="item.largeparagraphcontent"></div>
    </div>
  </section>
}
